module.exports = __webpack_public_path__ + "static/img/img5.c36b894e.png";